// 回收藥物 component

<template lang="pug">
div
  div.upper-subpanel.row
    progressBar
    div.upper-subpanel--without-progressbar(v-if="currentSystem.return_cmpn !== null")
      EventTable(v-if="stage === 'selectEvent'" :eventType="eventType" :device="currentSystem.return_cmpn")
      MultiFlow(v-if="stage === 'setFlowData'"
      :multiProgress="multiProgress"
      :confirmProgress="confirmProgress"
        v-on:setAllConfirmData="getAllConfirmData")
      Loader(v-if="stage === 'finish'")
    div.upper-subpanel--without-progressbar(v-else)
      div.upper-subpanel--inside
        h3 請先至首頁設定退藥盒
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
    action-button(title="開始回收" slot="button-9" @click.native="startFlow" v-if="stage === 'selectEvent'" :clickable="$store.state.event.selectedEventId.length !== 0")
</template>

<script>
import axios from 'axios';
import progressBar from './flowComp/ProgressBar';
import EventTable from './flowComp/EventTable';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';
import MultiFlow from './RecycleDrugFlow/MultiFlow';
import AppBase from './ComponentBase/AppBase';

export default {
  name: 'RecycleDrug',
  extends: AppBase,
  data() {
    return {
      eventType: 'RETURN',
    };
  },
  computed: {
    currentSystem() {
      return this.$store.getters.currentSystem;
    },
  },
  components: {
    progressBar,
    EventTable,
    Loader,
    MultiFlow,
    BottomButtons,
  },
  created() {
    this.stage = 'selectEvent';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
  },
  mounted() {
  },
  methods: {
    setupProgress() {
      return [
        { en: 'selectEvent', zh: '選擇退藥紀錄' },
        { en: 'action', zh: '進行回收' },
      ];
    },
    setupMultiProgress() {
      return [
        'confirm',
        'finish',
      ];
    },
    setupConfirmProgress() {
      return [
        'action',
        'finish',
      ];
    },
    cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RECYCLE' });
    },
    startFlow() {
      if (this.$store.state.event.selectedEventId.length !== 0) {
        this.stage = 'setFlowData';
      } else {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請置少選擇一項事件' });
      }
    },
    getAllConfirmData(data) {
      this.$store.dispatch('resetAll');
      this.stage = 'finish';
      setTimeout(() => {
        this.stage = 'selectEvent';
      }, 1300);
      // this.$router.push({ name: 'Main' });
    },
  },
};
</script>




// WEBPACK FOOTER //
// RecycleDrug.vue?405ea1f5